module.exports = __webpack_public_path__ + "img/ricky lee-web.bd727f17.jpg";